export const ALERTS = {
  ALERTS: {
    PAGE: "alerts/page",
    GET: "alerts/get",
    UPDATE_STATE: "alerts/update-state",
    ESCALATE: "alerts/escalate",
  },
};